export const ru = {
    'copy-link': 'Копировать список условий',
    ots: 'OTS',
    'predictor-error': 'Прогноз временно недоступен',
    'predictor-seven-days': 'Прогноз охвата за 7 дней',
    reach: 'Охват'
};
